import { useDispatch, useSelector } from "react-redux";

import Model from "@tripian/model";
import { api } from "@tripian/core";
import { useCallback } from "react";
import ICombinedState from "../redux/model/ICombinedState";
import { loginFinally, logoutFinally } from "../redux/action/user";
import { clear } from "../redux/action/trip";
import { refreshProviders } from "../App/AppWrapper/init";

const useAuth = () => {
  const { isLoggedIn, loadingIsLoggedIn } = useSelector(
    (state: ICombinedState) => ({
      isLoggedIn: state.user.isLoggedIn,
      loadingIsLoggedIn: state.user.loading.user,
    })
  );
  const dispatch = useDispatch();

  const registerEmail = useCallback(
    (registerRequest: Model.RegisterRequest): Promise<Model.Token> =>
      api.register({
        email: registerRequest.email,
        password: registerRequest.password,
        firstName: registerRequest.firstName,
        lastName: registerRequest.lastName,
        captchaToken: registerRequest.captchaToken,
      }),
    []
  );

  // Backend providers'ı yalnızca giriş yapmış kullanıcıya gönderiyor; giriş
  // durumuna geçmeden önce sağlayıcıları token'la yeniden çekiyoruz ki
  // giriş sonrası açılan sayfalar sağlayıcıları hazır bulsun.
  const loggedIn = useCallback(async (): Promise<void> => {
    await refreshProviders();
    dispatch(loginFinally());
  }, [dispatch]);

  const logout = useCallback((): void => {
    api.logout();
    dispatch(logoutFinally());
    dispatch(clear());
  }, [dispatch]);

  return { isLoggedIn, loadingIsLoggedIn, registerEmail, loggedIn, logout };
};

export default useAuth;
